<script setup lang="ts">
import { PropType } from 'vue'
import { getUrl } from '~/constants/urls'

const XECI_URLS = {
  privacyPolicy: getUrl('XECI_PRIVACY_POLICY'),
  termsAndConditions: getUrl('XECI_TERMS_CONDITIONS'),
}
const props = defineProps({
  from: {
    type: String as PropType<'signin' | 'signup'>,
    required: true,
    validator: (prop: string) => ['signin', 'signup'].includes(prop),
  },
})
</script>

<template>
  <section>
    <hr class="line" />
    <div>
      <template v-if="props.from === 'signin'">
        <i18n-t keypath="component.xeciT&c.signin" tag="p" scope="global" class="xeciBlurb">
          <template #terms>
            <OenUiLink
              :text="$t('component.xeciT&c.t&c')"
              theme="primary"
              :href="XECI_URLS.termsAndConditions"
              target="xeci-terms"
            />
          </template>
          <template #privacy>
            <OenUiLink
              :text="$t('component.XeRecaptcha.privacyPolicyLinkText')"
              theme="primary"
              :href="XECI_URLS.privacyPolicy"
              target="xeci-privacy"
            />
          </template>
        </i18n-t>
      </template>

      <template v-if="props.from === 'signup'">
        <i18n-t keypath="component.xeciT&c.signup" tag="p" scope="global" class="xeciBlurb">
          <template #terms>
            <OenUiLink
              :text="$t('component.xeciT&c.t&c')"
              theme="primary"
              :href="XECI_URLS.termsAndConditions"
              target="xeci-terms"
            />
          </template>
          <template #privacy>
            <OenUiLink
              :text="$t('component.XeRecaptcha.privacyPolicyLinkText')"
              theme="primary"
              :href="XECI_URLS.privacyPolicy"
              target="xeci-privacy"
            />
          </template>
        </i18n-t>
      </template>
    </div>
  </section>
</template>

<style scoped>
.xeciBlurb {
  @apply text-xs text-center pr-5 leading-[1.05rem] mb-4;

  a {
    @apply text-xs leading-[1.05rem] !important;
  }
}
</style>
